import React from 'react';

export default function SegmentedControl({ value, options, onChange, compact = false }) {
  return (
    <div className={`prospecting-segmented ${compact ? 'is-compact' : ''}`} role="group">
      {options.map((option) => (
        <button
          type="button"
          key={option.value}
          className={value === option.value ? 'is-active' : ''}
          onClick={() => !option.disabled && onChange(option.value)}
          disabled={option.disabled}
          title={option.title || ''}
        >
          {option.label}
          {option.badge ? <span className="prospecting-segment-badge">{option.badge}</span> : null}
        </button>
      ))}
    </div>
  );
}
